"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const work_registration_forms_1 = require("@Const/work-registration-forms");
const react_helmet_1 = __importDefault(require("react-helmet"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const FileUploadBottomNavBar_1 = __importDefault(require("@Components/CreateWorkBottomNavs/FileUploadBottomNavBar"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const CreateWorkByFileUploadLayout = () => {
    const { rightsholderStore, workStore, bulkUploadStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [currentStep, setCurrentStep] = (0, react_1.useState)(0);
    const [currentStepType, setCurrentStepType] = (0, react_1.useState)();
    const [backLink, setBackLink] = (0, react_1.useState)();
    const [nextLink, setNextLink] = (0, react_1.useState)();
    const setLinksToBar = (stepNumber) => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId;
        switch (stepNumber) {
            case 1:
                setBackLink(navigation_1.default.rightholder.summary(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.bulk.fileReview(currentRightsholderId));
                setCurrentStepType('File upload');
                break;
            case 2:
                setBackLink(navigation_1.default.rightholder.createWork.bulk.fileUpload(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.bulk.submission(currentRightsholderId));
                setCurrentStepType('File review');
                break;
            case 3:
                setNextLink(navigation_1.default.rightholder.createWork.bulk.fileReview(currentRightsholderId));
                setCurrentStepType('Edit work');
                break;
            case 4:
                setBackLink(navigation_1.default.rightholder.createWork.bulk.fileReview(currentRightsholderId));
                setCurrentStepType('Submission');
                break;
            default:
                setBackLink(navigation_1.default.rightholder.createWork.bulk.root(currentRightsholderId));
                setNextLink(navigation_1.default.rightholder.createWork.bulk.root(currentRightsholderId));
                setCurrentStepType('');
                break;
        }
    };
    const getCurrentStep = () => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId;
        switch (location.pathname) {
            case navigation_1.default.rightholder.createWork.bulk.root(currentRightsholderId):
            case navigation_1.default.rightholder.createWork.bulk.fileUpload(currentRightsholderId):
                return 1;
            case navigation_1.default.rightholder.createWork.bulk.fileReview(currentRightsholderId):
                return 2;
            case navigation_1.default.rightholder.createWork.bulk.edit.root(currentRightsholderId):
                return 3;
            case navigation_1.default.rightholder.createWork.bulk.submission(currentRightsholderId):
                return 4;
            default:
                // this value needs to be 0, it's ok that it doesn't match the switch case above, legacy magic number logic
                return 0;
        }
    };
    const initWorkDraft = () => workStore.setWorkDraftToLocal(work_registration_forms_1.CLEAR_WORK_DRAFT);
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_registration_new_work_bulk');
        initWorkDraft();
        return () => {
            bulkUploadStore.destroyWorksOnCurrentPage();
            workStore.destroyDraftWork();
            bulkUploadStore.destroyStartTitlePositionWorkSubmissions();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const stepNumber = getCurrentStep();
        setCurrentStep(stepNumber);
        setLinksToBar(stepNumber);
    }, [location]);
    const workDraftFromLocal = workStore.workDraftLocal;
    if (!workDraftFromLocal) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: "Create work by form" }),
        react_1.default.createElement("div", { className: "create-work-scene global-container" },
            react_1.default.createElement("div", { className: "steps-wrapper" },
                currentStep === 1 && (react_1.default.createElement(ContentHeader_1.default, { title: `Create Work: ${currentStepType}`, descriptionElement: react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null, "Bulk Registration is where you can register up to 300 rows of data at one time."),
                        react_1.default.createElement("p", null,
                            "For formatting tips, please read the help content below. For general information on completing bulk work registration, you can review our Help Center article",
                            react_1.default.createElement("a", { href: 'https://help.themlc.com/en/support/how-do-i-complete-the-bulk-work-document' },
                                ' ',
                                "here."))) })),
                react_1.default.createElement(react_router_dom_1.Outlet, null),
                currentStep !== 0 && (react_1.default.createElement(FileUploadBottomNavBar_1.default, { nextLink: nextLink, backLink: backLink, currentStep: currentStep, navigate: navigate }))))));
};
exports.default = CreateWorkByFileUploadLayout;
